import React, { useState } from 'react';
import Input from '@dealroadshow/uikit/core/components/Input';
import IconFiltering from '@dealroadshow/uikit/core/components/Icon/IconFiltering';

import styles from './loanLevelHeader.scss';

const Search = ({ onSearchChange }) => {
  const [searchString, setSearchString] = useState('');
  const handleSearchChange = ({ target: { value } }) => {
    onSearchChange(value);
    setSearchString(value);
  };

  return (
    // @ts-ignore
    <Input
      value={ searchString }
      onChange={ handleSearchChange }
      name="searchLoanLevel"
      dataTest="searchLoanLevel"
      isNarrow
      isClearable
      className={ styles.inputSearch }
      icon={ IconFiltering }
      placeholder="Filter by Sector, Issuer and Sponsor"
      iconPosition="left"
    />
  );
};

export default Search;
